import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin/dashboard");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A1628] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 mx-auto bg-white/5 border border-white/10 flex items-center justify-center mb-6">
            <Lock size={28} className="text-[#00D68F]" />
          </div>
          <h1 className="text-3xl font-black text-white tracking-tighter">
            Admin Login
          </h1>
          <p className="text-white/50 text-sm mt-2">EnergyX Dashboard</p>
        </div>

        {error && (
          <div
            className="bg-red-500/10 text-red-400 p-4 mb-6 text-sm font-bold text-center"
            data-testid="login-error"
          >
            {error}
          </div>
        )}

        <form
          onSubmit={handleSubmit}
          className="space-y-4"
          data-testid="login-form"
        >
          <Input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            data-testid="login-email"
            className="bg-white/5 border-white/10 text-white h-12 placeholder:text-white/30"
          />
          <Input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            data-testid="login-password"
            className="bg-white/5 border-white/10 text-white h-12 placeholder:text-white/30"
          />
          <Button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full bg-[#00D68F] text-[#0A1628] h-12 font-bold hover:-translate-y-0.5 transition-all"
          >
            {loading ? "Signing in..." : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
}
